(function (ws) {
    'use strict';
    ws.views.header = ws.views.googleAnalytics.extend({

        /**
         * Google Analytics Variables
         */
        GTM_EVENT_CATEGORY: 'user',
        GTM_LOGOUT_EVENT_ACTION: 'logout',
        GTM_EVENT_PACKING_SLIP_CATEGORY: 'order_activity',
        GTM_EVENT_ACTION_PACKING_SLIP: 'packing_slip',
        GTM_EVENT_ACTION_PACKING_SLIP_LABEL: 'click_navigation_bar',

        /**
         * Events
         */
        events: {
            'touchstart ul.hed-left > li > a': 'showSubMenu',
            'touchstart .overlay-menu': 'closeSubMenu',
            'click .cancel': 'closeSelectMenu',
            'click .modal-container': 'closeSelectMenu',
            'click #PackingSlipNavLink': 'capturingPackingSlipNavEvent',
            'click .cview.single.in-active': 'capturingSingleViewEvent',
            'click .cview.multi.in-active': 'capturingMultiViewEvent',
            'click .min-view-close': 'closeOverlay'
        },

        /**
         * Initialize
         */
        initialize: function () {
            this.$miniCart = this.$('.hed-minicart');
            this.$select = this.$('.usi-cart-overlay');
            this.$mainSubMenu = this.$('.hed-dropdown-menu-contanier');
            this.$mainMenuNav = this.$('nav ul li');
            this.$overlayMenu = this.$('.overlay-menu');
            this.$switchOverlay = this.$('.switch.overlay');
            this.$redirectURL = this.$('.view-buttons').data('url');
            this.$multiView = this.$('.view-buttons').data('show-multiview');

            let url = window.location.href;
            let str = url.split('/');
            let searchReseller = str[str.length - 1];
            if (searchReseller === 'resellerSearch') {
                $('.cust-onboard-button').removeClass('hidden');
                $('.cust-onboard-button-div').removeClass('hidden');
            }

            if (this.$redirectURL !== undefined) {
                if (this.$multiView === true) {
                    $('.multi').addClass('active');
                    $('.single').addClass('in-active');
                    this.$redirectURL = this.$redirectURL.concat('?preferredView=SINGLE_VIEW');
                } else {
                    $('.multi').addClass('in-active');
                    $('.single').addClass('active');
                    this.$redirectURL = this.$redirectURL.concat('?preferredView=MULTI_VIEW');
                }

                this.$('.min-view-go').attr('href', this.$redirectURL);
            }

            this.render();
            $('.tab-title a').on('click', (e) => {
                this.showTab(e);
            });
        },

        /**
         * Show Tabs
         * @param {Object} e
         */
        showTab: function (e) {
            e.preventDefault();
            var $el = $(e.currentTarget);
            var tabId = $el.attr('href');
            $('.tab-title').removeClass('active');
            $el.parent().addClass('active');
            $(tabId).show().siblings().hide();
        },

        /**
         * Render function
         */
        render: function () {
            this.renderMiniCart();
            this.mainMenuRenderer();
        },

        /**
         * Handle packing slip navigation link click and trigger analytics event
         *
         */
        capturingPackingSlipNavEvent: function () {
            this.gtmEventTracking(this.GTM_EVENT_PACKING_SLIP_CATEGORY, this.GTM_EVENT_ACTION_PACKING_SLIP, this.GTM_EVENT_ACTION_PACKING_SLIP_LABEL);
        },

        /**
         * To handle the menu/sub-menu functionality based on sub-menu url,
         * If sub-menu is not consisting main-menu url removing the href from main menu
         */
        mainMenuRenderer: function () {
            // Loop main-menu links
            this.$mainMenuNav.each(function () {
                var mainMenusHref = $(this).children('a').attr('href');
                var mainMenuOccurance = 0;
                var subMenus = $(this).find('li');

                // Compare only if sub-menu is present
                if (subMenus.length > 0) {

                    // Loop all sub-menu links and compare with main-menu link
                    // If match found update maniMenuOccurance to 1
                    subMenus.each(function () {
                        var subMenusHref = $(this).children('a').attr('href');
                        if ((mainMenusHref === subMenusHref) || (mainMenusHref + '?page=0' === subMenusHref)) {
                            mainMenuOccurance = 1;
                        }
                    });

                    // If no match found then remove the link for main-menu
                    if (mainMenuOccurance === 0) {
                        $(this).children('a').removeAttr('href');
                    }
                }
            });
        },

        /**
         * Render Mini Cart
         */
        renderMiniCart: function () {
            if (this.$miniCart.length !== 0) {
                return new ws.views.minicart({
                    el: this.$miniCart
                });
            }
        },

        /**
         * Close user select menu
         */
        closeSelectMenu: function () {
            this.$select.hide();
        },

        /**
         * Sub Menu Open
         * @param {Object} e
         */
        showSubMenu: function (e) {

            this.$mainSubMenu.hide();
            this.$overlayMenu.hide();
            var dashbord = $(e.target).parent().children('div').attr('id');

            if (dashbord != 'ServiceCategoryComponent') {
                e.preventDefault();
            }

            $(e.target).parent().children('div').show();
            this.$overlayMenu.show();

        },

        /**
         * Sub Menu Close
         * @param {Object} e
         */
        closeSubMenu: function (e) {
            e.preventDefault();
            this.$mainSubMenu.hide();
            this.$overlayMenu.hide();
        },

        /*
         *  Single View Menu Open
         */
        capturingSingleViewEvent: function (e) {
            $('.switch.overlay').toggle();
            $('.switch.overlay .arrow').toggleClass('single');
        },

        /*
         *  Multi View Menu Open
         */
        capturingMultiViewEvent: function (e) {
            $('.switch.overlay').toggle();
            $('.switch.overlay .arrow').toggleClass('multi');
        },

        closeOverlay: function () {
            this.$switchOverlay.hide();
        }
    });
})(westcon);
